'use client';

import { getFragmentData } from '@/__generated__';
import { ENTRY_BASE_FRAGMENT } from '@/gql/fragments/entries.gql';
import useScrollPosition from '@/lib/utils/useScrollPosition';
import { useBreakpointMin } from '@/theme';
import IconButton from '../IconButton';
import Flex from '../ui/Flex';
import { useNavBar } from './useNavBar';
import { useNavbarActions } from './useNavbarState';

interface NavIconsProps {
  search?: boolean;
}

export default function NavIcons({ search = true }: NavIconsProps) {
  const md = useBreakpointMin('md');
  const { shoppingBasket, profile, page } = useNavBar();
  const setSearch = useNavbarActions((s) => s.setSearch);
  const pos = useScrollPosition();

  const base = getFragmentData(ENTRY_BASE_FRAGMENT, page);
  const eventUri = base?.sectionHandle === 'event';

  const color = pos < 10 && eventUri ? 'white' : 'black';

  if (!md) return null;

  return (
    <Flex direction="row" alignItems="center" columnGap="xs">
      <IconButton
        icon="shoppingCart"
        href={shoppingBasket?.externalUrl ?? ''}
        disableTransition
        target="_self"
        size="small"
        color={color}
      />
      <IconButton
        icon="profile"
        href={profile?.externalUrl ?? ''}
        disableTransition
        target="_self"
        size="small"
        color={color}
      />
      {search && (
        <IconButton
          onClick={() => setSearch(true)}
          icon="search"
          size="small"
          color={color}
          disableTransition
        />
      )}
    </Flex>
  );
}
